/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from 'react-router-dom';

import { useIsMobile } from '../../utils/hooks';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { track } from '../../utils/track';
import { IS_SINGLE_TENENT_MODE } from '../../constants';

export function BackButton({ to, desc }) {
  return (
    <Link
      to={to}
      css={css`
        text-decoration: none;
      `}
    >
      <Button
        css={css`
          margin-right: auto;
          display: flex;
          align-items: center;
          text-decoration: none;
          color: var(--text-secondary);
        `}
      >
        <ArrowBackIcon
          css={css`
            margin-right: 0.5rem;
          `}
        />
        {desc}
      </Button>
    </Link>
  );
}

export function ResponsiveButton({ children, startIcon, breakPoint, ...rest }) {
  const { isMobile, width } = useIsMobile();
  if (isMobile || width < breakPoint) {
    return <IconButton {...rest}>{startIcon}</IconButton>;
  } else {
    return (
      <Button startIcon={startIcon} {...rest}>
        {children}
      </Button>
    );
  }
}

export function UpgradeButton({ text, event, onClick, ...rest }) {
  if (IS_SINGLE_TENENT_MODE) {
    return null;
  }

  return (
    <Button
      {...rest}
      onClick={() => {
        if (event) {
          track(event);
        }
        if (typeof onClick === 'function') {
          onClick();
        }
      }}
      component={Link}
      to="/profile/billing"
      color="text"
      variant="outlined"
      css={css`
        margin-top: 8px;
        border: 1px solid rgba(0, 0, 0, 0.87);
        background: linear-gradient(
          269deg,
          rgba(251, 188, 4, 0.29) 0%,
          rgba(255, 255, 255, 0.54) 58.1%
        );
        overflow: hidden;

        ::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to right,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.8) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          transition: all 0.5s;
          pointer-events: none;
          animation: shine 10s infinite;
        }

        @keyframes shine {
          0% {
            left: -100%;
          }
          90% {
            left: -100%;
          }
          100% {
            left: 100%;
          }
        }
      `}
      startIcon={<RocketLaunchIcon />}
    >
      {text}
    </Button>
  );
}
